import {Autocomplete, Paper, TextField} from '@mui/material';
import sortBy from 'lodash/sortBy';
import {array, bool, func, object} from 'prop-types';
import React, {useMemo} from 'react';
import ProductOption from './ProductOption.jsx';

const ProductsDropDown = ({products, value = null, onChange, isLoading}) => {
  const sortedProducts = useMemo(() => sortBy(products, 'title'), [products]);

  return (
    <Paper elevation={0}>
      <Autocomplete
        disablePortal
        fullWidth
        size="small"
        autoHighlight
        options={sortedProducts}
        loading={isLoading}
        value={value}
        getOptionLabel={option => {
          return option?.title || '';
        }}
        renderInput={params => (
          <TextField {...params} label="Select a product" />
        )}
        renderOption={(props, option) => (
          <ProductOption {...props} key={option.id} product={option} divider />
        )}
        isOptionEqualToValue={(option, value) => {
          return option.id === value?.id;
        }}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
      />
    </Paper>
  );
};

ProductsDropDown.propTypes = {
  products: array,
  value: object,
  onChange: func,
  isLoading: bool,
};

export default ProductsDropDown;
